
import { useState, useEffect, useRef } from 'react';

const testimonials = [
  {
    id: 1,
    name: 'Grace Nakamya',
    role: 'Marketing Director',
    company: 'Kampala Serena Hotel',
    location: 'Kampala, Uganda',
    flag: '🇺🇬',
    avatar:
      'https://readdy.ai/api/search-image?query=Professional%20African%20woman%20executive%20portrait%20headshot%20warm%20lighting%20confident%20smile%20business%20attire%20studio%20background%20elegant%20corporate%20photography%20Ugandan%20woman&width=200&height=200&seq=testimonial-avatar-001&orientation=squarish',
    quote:
      'Asili Visuals completely transformed our brand presence. Their strategic approach to our visual identity and digital campaigns resulted in a 40% increase in direct bookings within six months. Truly world‑class work from a Kampala‑based team.',
    rating: 5,
    project: 'Brand Identity & Digital Campaign',
  },
  {
    id: 2,
    name: 'James Ochieng',
    role: 'CEO',
    company: 'Savannah Logistics Ltd',
    location: 'Nairobi, Kenya',
    flag: '🇰🇪',
    avatar:
      'https://readdy.ai/api/search-image?query=Professional%20African%20man%20executive%20portrait%20headshot%20warm%20lighting%20confident%20smile%20business%20suit%20studio%20background%20corporate%20photography%20Kenyan%20businessman&width=200&height=200&seq=testimonial-avatar-002&orientation=squarish',
    quote:
      'From our fleet branding to billboard campaigns across the Northern Corridor, Asili delivered with precision and creativity. They understand the East African market like no other agency we have worked with. Our brand recognition tripled.',
    rating: 5,
    project: 'Vehicle Branding & Outdoor Advertising',
  },
  {
    id: 3,
    name: 'Amina Bashir',
    role: 'Communications Manager',
    company: 'Tanzania Investment Centre',
    location: 'Dar es Salaam, Tanzania',
    flag: '🇹🇿',
    avatar:
      'https://readdy.ai/api/search-image?query=Professional%20African%20woman%20portrait%20headshot%20warm%20lighting%20confident%20smile%20elegant%20business%20attire%20studio%20background%20corporate%20photography%20Tanzanian%20woman%20executive&width=200&height=200&seq=testimonial-avatar-003&orientation=squarish',
    quote:
      'The corporate documentary Asili produced for us was exceptional. It captured our mission with cinematic quality and strategic narrative that resonated with international investors. Their media production capabilities are outstanding.',
    rating: 5,
    project: 'Corporate Documentary & PR Strategy',
  },
  {
    id: 4,
    name: 'Patrick Mugisha',
    role: 'Founder & Managing Director',
    company: 'Pearl Agro Industries',
    location: 'Kampala, Uganda',
    flag: '🇺🇬',
    avatar:
      'https://readdy.ai/api/search-image?query=Professional%20African%20man%20portrait%20headshot%20warm%20lighting%20confident%20smile%20casual%20business%20attire%20studio%20background%20corporate%20photography%20Ugandan%20entrepreneur&width=200&height=200&seq=testimonial-avatar-004&orientation=squarish',
    quote:
      'Asili Visuals built our entire brand from the ground up — logo, packaging, website, and uniforms for our 200‑person team. The consistency across every touchpoint has made us look like a multinational. Incredible attention to detail.',
    rating: 5,
    project: 'Full Brand Development & Garment Manufacturing',
  },
  {
    id: 5,
    name: 'Diane Uwimana',
    role: 'Head of Marketing',
    company: 'Kigali Heights Mall',
    location: 'Kigali, Rwanda',
    flag: '🇷🇼',
    avatar:
      'https://readdy.ai/api/search-image?query=Professional%20African%20woman%20portrait%20headshot%20warm%20lighting%20confident%20smile%20modern%20business%20attire%20studio%20background%20corporate%20photography%20Rwandan%20woman%20marketing%20executive&width=200&height=200&seq=testimonial-avatar-005&orientation=squarish',
    quote:
      'Their content strategy and social media management transformed our online presence. Foot traffic increased by 35% after their digital campaign launch. Asili understands how to connect brands with East African consumers authentically.',
    rating: 5,
    project: 'Digital Marketing & Content Strategy',
  },
  {
    id: 6,
    name: 'Samuel Lado',
    role: 'Director of Operations',
    company: 'Juba Construction Group',
    location: 'Juba, South Sudan',
    flag: '🇸🇸',
    avatar:
      'https://readdy.ai/api/search-image?query=Professional%20African%20man%20portrait%20headshot%20warm%20lighting%20confident%20smile%20business%20attire%20studio%20background%20corporate%20photography%20South%20Sudanese%20businessman%20executive&width=200&height=200&seq=testimonial-avatar-006&orientation=squarish',
    quote:
      'Working with Asili on our corporate rebrand was seamless despite the distance. They delivered billboard designs, branded safety gear, and a company profile that won us three government contracts. Professional and reliable.',
    rating: 5,
    project: 'Corporate Rebrand & Outdoor Advertising',
  },
];

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);
  const autoPlayRef = useRef<ReturnType<typeof setInterval> | null>(null);

  // Observe when the section enters the viewport
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.1 },
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  // Guard against rapid clicks while animation is in progress
  const goTo = (index: number) => {
    if (isAnimating) return;
    setIsAnimating(true);
    setActiveIndex(index);
    setTimeout(() => setIsAnimating(false), 500);
  };

  const next = () => goTo((activeIndex + 1) % testimonials.length);
  const prev = () => goTo((activeIndex - 1 + testimonials.length) % testimonials.length);

  // Autoplay – reset timer whenever the active index changes
  useEffect(() => {
    // Clear any existing interval before creating a new one
    if (autoPlayRef.current) clearInterval(autoPlayRef.current);
    autoPlayRef.current = setInterval(next, 6000);
    return () => {
      if (autoPlayRef.current) clearInterval(autoPlayRef.current);
    };
  }, [activeIndex]);

  const current = testimonials[activeIndex];

  return (
    <section
      ref={sectionRef}
      id="testimonials"
      className="relative py-16 sm:py-20 lg:py-28 overflow-hidden"
      style={{
        background:
          'linear-gradient(135deg, #FFFBF5 0%, #FFF7EE 50%, #FFF5F0 100%)',
      }}
    >
      {/* Decorative background elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-[#038C7F]/5 rounded-full blur-[120px]"></div>
        <div className="absolute bottom-0 right-0 w-[350px] h-[350px] bg-[#F2780C]/5 rounded-full blur-[120px]"></div>
        <div className="absolute top-20 right-20 text-[200px] sm:text-[280px] font-serif text-[#F2780C]/[0.04] leading-none select-none hidden lg:block">
          &ldquo;
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        {/* Header */}
        <div
          className={`text-center mb-10 sm:mb-14 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-[#F2780C]/10 rounded-full mb-4">
            <i className="ri-chat-quote-line text-[#F2780C] text-sm"></i>
            <span className="text-[10px] sm:text-xs font-bold text-[#F2780C] uppercase tracking-[0.2em]">
              Client Testimonials
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-[#0D0D0D] leading-tight">
            Trusted Across{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#038C7F] to-[#F2780C]">
              East Africa
            </span>
          </h2>
          <p className="text-sm sm:text-base text-gray-500 mt-3 max-w-xl mx-auto">
            Real results from real partnerships across Uganda, Kenya, Tanzania,
            Rwanda, and South Sudan.
          </p>
        </div>

        {/* Main Testimonial Card */}
        <div
          className={`transition-all duration-700 delay-200 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="relative max-w-5xl mx-auto">
            <div className="bg-white rounded-2xl sm:rounded-3xl shadow-xl border border-gray-100 overflow-hidden">
              <div className="grid lg:grid-cols-5">
                {/* Left – Client Info */}
                <div className="lg:col-span-2 bg-gradient-to-br from-[#0D0D0D] to-[#1a1a1a] p-6 sm:p-8 lg:p-10 flex flex-col justify-between relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-32 h-32 bg-[#038C7F]/10 rounded-full blur-2xl"></div>
                  <div className="absolute bottom-0 left-0 w-24 h-24 bg-[#F2780C]/10 rounded-full blur-2xl"></div>

                  <div className="relative">
                    <div key={`info-${current.id}`} className="animate-fadeIn">
                      <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl overflow-hidden border-2 border-white/20 mb-5">
                        <img
                          src={current.avatar}
                          alt={current.name}
                          className="w-full h-full object-cover object-top"
                        />
                      </div>

                      <h3 className="text-xl sm:text-2xl font-bold text-white mb-1">
                        {current.name}
                      </h3>
                      <p className="text-sm text-gray-400 mb-1">{current.role}</p>
                      <p className="text-sm font-semibold text-[#038C7F] mb-3">
                        {current.company}
                      </p>

                      <div className="flex items-center gap-2 mb-5">
                        <span className="text-base">{current.flag}</span>
                        <span className="text-xs text-gray-500">
                          {current.location}
                        </span>
                      </div>

                      <div className="inline-block px-3 py-1.5 bg-white/5 border border-white/10 rounded-lg">
                        <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">
                          Project
                        </span>
                        <p className="text-xs text-white font-medium mt-0.5">
                          {current.project}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Stars */}
                  <div className="flex items-center gap-1 mt-6 lg:mt-0">
                    {[...Array(current.rating)].map((_, i) => (
                      <i
                        key={i}
                        className="ri-star-fill text-[#F2780C] text-lg"
                      ></i>
                    ))}
                    <span className="text-sm font-bold text-white ml-2">
                      {current.rating}.0
                    </span>
                  </div>
                </div>

                {/* Right – Quote */}
                <div className="lg:col-span-3 p-6 sm:p-8 lg:p-10 flex flex-col justify-between">
                  <div>
                    <i className="ri-double-quotes-l text-5xl sm:text-6xl text-[#038C7F]/15 leading-none block mb-4"></i>
                    <p
                      key={`quote-${current.id}`}
                      className="text-base sm:text-lg lg:text-xl text-[#0D0D0D] font-medium leading-relaxed animate-fadeIn"
                    >
                      {current.quote}
                    </p>
                  </div>

                  {/* Navigation */}
                  <div className="flex items-center justify-between mt-8 pt-6 border-t border-gray-100">
                    <div className="flex items-center gap-2">
                      {testimonials.map((_, idx) => (
                        <button
                          key={idx}
                          onClick={() => goTo(idx)}
                          className={`transition-all duration-300 rounded-full cursor-pointer ${
                            idx === activeIndex
                              ? 'w-8 h-2.5 bg-[#038C7F]'
                              : 'w-2.5 h-2.5 bg-gray-200 hover:bg-gray-300'
                          }`}
                          aria-label={`Go to testimonial ${idx + 1}`}
                        ></button>
                      ))}
                    </div>

                    <div className="flex items-center gap-2">
                      <button
                        onClick={prev}
                        className="w-10 h-10 sm:w-11 sm:h-11 rounded-full border border-gray-200 flex items-center justify-center hover:bg-[#038C7F] hover:border-[#038C7F] hover:text-white text-gray-600 transition-all duration-300 cursor-pointer"
                      >
                        <i className="ri-arrow-left-s-line text-xl"></i>
                      </button>
                      <button
                        onClick={next}
                        className="w-10 h-10 sm:w-11 sm:h-11 rounded-full bg-[#0D0D0D] text-white flex items-center justify-center hover:bg-[#038C7F] transition-all duration-300 cursor-pointer"
                      >
                        <i className="ri-arrow-right-s-line text-xl"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Client Logos / Trust Strip */}
        <div
          className={`mt-12 sm:mt-16 transition-all duration-700 delay-400 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <p className="text-center text-[10px] sm:text-xs font-bold text-gray-400 uppercase tracking-[0.2em] mb-6">
            Brands That Trust Us
          </p>
          <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-10">
            {[
              { name: 'Kampala Serena', icon: 'ri-hotel-line' },
              { name: 'Savannah Logistics', icon: 'ri-truck-line' },
              { name: 'Tanzania Investment', icon: 'ri-government-line' },
              { name: 'Pearl Agro', icon: 'ri-plant-line' },
              { name: 'Kigali Heights', icon: 'ri-building-4-line' },
              { name: 'Juba Construction', icon: 'ri-building-line' },
            ].map((brand, idx) => (
              <div
                key={idx}
                className="flex items-center gap-2 px-4 py-2.5 bg-white/80 border border-gray-100 rounded-xl hover:shadow-md hover:border-[#038C7F]/30 transition-all duration-300 cursor-default"
              >
                <div className="w-8 h-8 bg-gray-50 rounded-lg flex items-center justify-center">
                  <i className={`${brand.icon} text-base text-gray-400`}></i>
                </div>
                <span className="text-xs font-semibold text-gray-500">
                  {brand.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Inline keyframes – moved to a <style> tag using dangerouslySetInnerHTML for safety */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
            @keyframes fadeIn {
              from { opacity: 0; transform: translateY(8px); }
              to { opacity: 1; transform: translateY(0); }
            }
            .animate-fadeIn {
              animation: fadeIn 0.5s ease-out;
            }
          `,
        }}
      />
    </section>
  );
}
